export default __webpack_public_path__ + "static/mainHeaderImg-634a136e901aabb9c5adadc6bc8565cd.webp";